import { create } from "zustand";

const useNotificationStore = create((set) => ({
  notification: false,
  isOpen: false,

  actions: {
    setNotification: (value) => {
      set({ notification: value });
    },
    setIsOpen: (value, notification = null) => {
      set((state) => ({
        isOpen: value,
        notification: notification !== null ? notification : state.notification,
      }));
    },
  },
}));

// State hooks
export const useNotification = () => useNotificationStore((state) => state.notification);
export const useIsNotificationOpen = () => useNotificationStore((state) => state.isOpen);

// Actions hook
export const useNotificationActions = () => useNotificationStore((state) => state.actions);
